import { marked } from 'marked'

// Configure marked for safe HTML rendering
marked.setOptions({
    headerIds: false,
    mangle: false,
    sanitize: false, // We'll use DOMPurify if needed later
    breaks: true, // Convert \n to <br>
    gfm: true // GitHub Flavored Markdown
})

// Simple markdown renderer for chat messages
export function renderMarkdown(text) {
    if (!text) return ''

    // Convert markdown to HTML
    const html = marked(text)

    // Clean up common markdown issues in chat context
    return html
        .replace(/<p>/g, '<p class="mb-2">')  // Add spacing between paragraphs
        .replace(/<h(\d)>/g, '<h$1 class="font-semibold text-lg mb-2">') // Style headers
        .replace(/<strong>/g, '<strong class="font-semibold">') // Ensure bold styling
        .replace(/<ul>/g, '<ul class="list-disc list-inside mb-2">') // Style lists
        .replace(/<ol>/g, '<ol class="list-decimal list-inside mb-2">') // Style ordered lists
        .replace(/<li>/g, '<li class="mb-1">') // Style list items
        .replace(/<code>/g, '<code class="bg-gray-100 px-1 rounded text-sm">') // Style inline code
}